/**
 * Path C — Nova 2 Sonic broker.
 *
 * Server URL: wss://<cloudfront-domain>/nova/ws → CloudFront → Nova Sonic ALB
 * (when the broker is redeployed and Phase 3 resumes).
 *
 * Wire format (per agents/nova_sonic/main.py):
 *   - Browser → broker: binary frames = raw 16 kHz mono PCM int16
 *   - Broker → browser: binary frames = raw 24 kHz mono PCM int16 (model audio)
 *   - Broker → browser: text frames = JSON events
 *       { type: "transcript", role: "USER"|"ASSISTANT", content: "..." }
 *       { type: "tool_use", name: "...", arguments: {...} }
 *       { type: "tool_result", name: "...", result: {...} }
 */
import { WebsocketAudioPathAdapter } from "./websocket-audio";

const ENDPOINT = (import.meta as any).env?.VITE_NOVA_URL || "/nova/ws";

export class NovaSonicPathAdapter extends WebsocketAudioPathAdapter {
  protected getEndpoint(): string {
    if (ENDPOINT.startsWith("ws")) return ENDPOINT;
    const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
    return `${proto}//${window.location.host}${ENDPOINT}`;
  }

  protected handleText(payload: string): void {
    try {
      const evt = JSON.parse(payload);
      if (evt.type === "transcript") {
        const role = evt.role === "USER" ? "user" : "bot";
        this.emit({ role, content: evt.content ?? "" });
      } else if (evt.type === "tool_use") {
        this.toolCalls += 1;
        this.emit({
          role: "tool",
          content: `${evt.name}(${JSON.stringify(evt.arguments ?? {})})`,
          toolName: evt.name,
        });
        this.pushMetric({});
      } else if (evt.type === "tool_result") {
        // Display tool results inline (truncated) so visitors can see what the model received.
        const summary = JSON.stringify(evt.result ?? {}).slice(0, 140);
        this.emit({ role: "tool", content: `→ ${summary}`, toolName: evt.name });
      }
    } catch {
      // Ignore malformed
    }
  }
}
